import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useActivitiesAPIClient = () => {
  const { get, set, remove, update } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getActivities = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/activities`),
    );
  }, [activeUser, get]);

  const createActivity = useCallback(
    async (activity) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/activities`, activity),
      );
    },
    [activeUser, set],
  );

  const updateActivity = useCallback(
    async (activityId, updates) => {
      return await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}/activities/${activityId}`, updates),
      );
    },
    [activeUser, update],
  );

  const deleteActivity = useCallback(
    async (activityId) => {
      return await withNetworkErrorHandling(() =>
        remove(`users/${activeUser.userId}/activities/${activityId}`),
      );
    },
    [activeUser, remove],
  );

  return { getActivities, createActivity, updateActivity, deleteActivity };
};

export default useActivitiesAPIClient;
